export const smsTimeout = 60 * 4 + 59;
